import { DelegatePersistLayoutParams } from '@common-modules/dynamic-layout/delegate-persist-layout/delegate-persist-layout-params';
import { SimpleDynamicLayoutSettings } from '@common-modules/dynamic-layout/layouts/simple-dynamic-layout-settings';
import { MasterOperatorConnectItemsSettings } from '../models/master-operator-connect-settings';
import { MasterOperatorType } from '../models/master-operator-type';

export class MasterOperatorSingleSettings extends DelegatePersistLayoutParams {
  isSingleSettings: boolean;
  type: MasterOperatorType;
  singleId: string;
  groupId: string;
  layout: SimpleDynamicLayoutSettings;
  connect?: MasterOperatorConnectItemsSettings;

  constructor(init?: Partial<MasterOperatorSingleSettings>) {
    super(init);
    Object.assign(this, init);
  }
}
